import React, { forwardRef, useEffect } from "react";
import { TextField, Box, InputAdornment } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import { cleanNumber } from "helpers/cleanNumbers";
import { useForm } from "hooks/useForm";
import { useDispatch, useSelector } from "react-redux";
import { updateInventoryDigital } from "redux/actions/inventories/inventoriesAction";

const UpdateInventoryDigitalInputComponent = forwardRef(
  ({ data, onClose, inventoryType, keyInventory, edited }, ref) => {
    const dispatch = useDispatch();

    const initialPercentage =
      data?.currentPercentage !== undefined && data?.currentPercentage !== null
        ? String(data.currentPercentage)
        : "";

    const { values, setValues, onChange } = useForm({
      currentPercentage: initialPercentage,
      comments: "",
    });

    const { currentPercentage, comments } = values;
    const { inventory } = useSelector((state) => state.inventories);
    const { isLoadingComp } = useSelector((state) => state.search);

    const handleSubmit = (e) => {
      e.preventDefault();
      const form = {
        ...data,
        id: data?.id,
        type: inventoryType?.toUpperCase(),
        currentPercentage: cleanNumber(currentPercentage),
        keyInventory,
        comments,
      };
      dispatch(updateInventoryDigital(inventory?.id, form, edited, onClose));
    };

    const handlePercentageChange = (e) => {
      let val = e?.target?.value ?? "";
      val = String(val).replace(/[^0-9.]/g, "");
      const parts = val.split(".");
      if (parts.length > 2) {
        val = parts[0] + "." + parts.slice(1).join("");
      }
      setValues({ currentPercentage: val });
    };

    useEffect(() => {
      if (currentPercentage === "" || currentPercentage === undefined) return;

      const currStr = String(currentPercentage);
      let cleaned = currStr.replace(/[^0-9.]/g, "");
      const parts = cleaned.split(".");
      if (parts.length > 2) cleaned = parts[0] + "." + parts.slice(1).join("");

      const parsed = parseFloat(cleaned);

      if (isNaN(parsed)) {
        if (cleaned !== currStr) setValues({ currentPercentage: cleaned });
        return;
      }

      const clamped = Math.min(Math.max(parsed, 0), 100);
      const finalStr = cleaned.endsWith(".") ? cleaned : String(clamped);

      if (finalStr !== currStr) setValues({ currentPercentage: finalStr });
    }, [currentPercentage, setValues]);

    return (
      <form onSubmit={handleSubmit}>
        <TextField
          variant="outlined"
          label="Porcentaje Digital"
          name="currentPercentage"
          value={currentPercentage}
          onChange={handlePercentageChange}
          inputProps={{ min: 0, max: 100, style: { textAlign: "right" } }}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          variant="outlined"
          label="Comentarios"
          name="comments"
          value={comments}
          onChange={onChange}
          multiline
          rows={4}
          fullWidth
        />
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <RegularButton
            color="transparent"
            onClick={onClose}
            disabled={isLoadingComp?.loadingUpdateDigitalInventory}
          >
            Cancelar
          </RegularButton>
          <RegularButton
            color="info"
            onClick={handleSubmit}
            loading={isLoadingComp?.loadingUpdateDigitalInventory}
          >
            Actualizar
          </RegularButton>
        </Box>
      </form>
    );
  }
);

export const UpdateInventoryDigitalInput = React.memo(
  UpdateInventoryDigitalInputComponent
);
